import type { QueryClient } from '@tanstack/react-query';

import type {
  Classroom,
  CoursesQuery,
  StudentsQuery,
} from '@innovamat/glow-api-client';
import { useCoursesQuery, useStudentsQuery } from '@innovamat/glow-api-client';
import type { Classroom as ClassroomType } from '@innovamat/radiance-utils';

import { parseClassroomStudents } from '../modules/classroom-student/classroom-student';
import type { ClassroomStudent } from '../views/classroom-students/types/classroom-student';

type Props = {
  queryClient: QueryClient;
  organizationId: string;
  region: string;
  updatedClassroom: Classroom;
};

function updateClassroomStudentsInCache({
  queryClient,
  organizationId,
  region,
  updatedClassroom,
}: Props): void {
  const studentsQueryKey = useStudentsQuery.getKey({
    organizationId,
    classroomId: updatedClassroom.id,
  });
  const courseQueryKey = useCoursesQuery.getKey({
    regionCode: region,
  });

  const courseQuery = queryClient.getQueryData<CoursesQuery>(courseQueryKey);

  const course = courseQuery?.courses.find(
    (course) => course.id === updatedClassroom.courseId
  );

  const finalUpdatesClassroom = {
    ...updatedClassroom,
    courseName: course?.name ?? updatedClassroom.courseName,
    courseOrder: course?.order ?? updatedClassroom.courseOrder,
  };

  const studentsQuery =
    queryClient.getQueryData<StudentsQuery>(studentsQueryKey);

  if (studentsQuery?.students) {
    queryClient.setQueryData(studentsQueryKey, {
      students: parseClassroomStudents(
        studentsQuery.students as ClassroomStudent[],
        finalUpdatesClassroom as ClassroomType
      ),
    });
  }
}

export { updateClassroomStudentsInCache };
